// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorInventoryItems = (client) => ({
    /**
     * `POST /vendor/inventory-items/:id/location-levels/batch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBatchInventoryItemLocationsLevels
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/batch/route.ts
     */
    batchLocationLevels: (id, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels/batch", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/inventory-items/:id/location-levels`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateInventoryLevel
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/route.ts
     */
    createLocationLevel: (id, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/inventory-items/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteInventoryItem
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/inventory-items/:id/location-levels/:location_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteInventoryLevel
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/[location_id]/route.ts
     */
    deleteLocationLevel: (id, locationId, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels/:location_id", [id, locationId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/inventory-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListInventoryItem
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/inventory-items", { method: "GET", query, headers }),
    /**
     * `GET /vendor/inventory-items/:id/location-levels`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetItemInventoryLevel
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/route.ts
     */
    listLocationLevels: (id, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/inventory-items/location-levels/batch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBatchInventoryItemLevels
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/location-levels/batch/route.ts
     */
    postBatchLocationLevels: (body, query, headers) => client.fetch("/vendor/inventory-items/location-levels/batch", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/inventory-items/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetInventoryItem
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/inventory-items/:id/location-levels/:location_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetInventoryLevel
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/[location_id]/route.ts
     */
    retrieveLocationLevel: (id, locationId, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels/:location_id", [id, locationId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/inventory-items/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateInventoryItem
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/inventory-items/:id/location-levels/:location_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateInventoryLevel
     * @source packages/modules/b2c-core/src/api/vendor/inventory-items/[id]/location-levels/[location_id]/route.ts
     */
    updateLocationLevel: (id, locationId, body, query, headers) => client.fetch(buildPath("/vendor/inventory-items/:id/location-levels/:location_id", [id, locationId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=inventory-items.js.map